<template>
    <transition name="pt-alert-fade">
        <div
            v-show="visible"
            class="pt-alert"
            :class="[typeClass, center ? 'is-center' : '', 'is-' + effect]"
            role="alert"
        >
            <pt-icon v-if="showIcon" :icon="iconClass" class="pt-alert__icon" :class="[iconClass, isBigIcon]"></pt-icon>
            <div class="pt-alert__content">
                <span v-if="title || $slots.title" class="pt-alert__title" :class="[isBoldTitle]">
                    <slot name="title">{{ title }}</slot>
                </span>
                <p v-if="$slots.default || !!description" class="pt-alert__description">
                    <slot>
                        {{ description }}
                    </slot>
                </p>
                <!-- <i
                    v-if="closable"
                    class="pt-alert__closebtn"
                    :class="{ 'is-customed': closeText !== '', 'pt-icon-close': closeText === '' }"
                    @click="close"
                >
                    {{ closeText }}
                </i> -->
                <pt-icon 
                    v-if="closable"
                    icon="pt-icon-clear"
                    class="pt-alert__closebtn"
                    :class="{ 'is-customed': closeText !== '', 'pt-icon-close': closeText === '' }"
                    @click="close"
                >

                </pt-icon>
            </div>
        </div>
    </transition>
</template>

<script lang="ts">
export default {
    name: 'PtAlert',
};
</script>

<script lang="ts" setup>
import { computed, ref, useSlots } from 'vue';

// const TYPE_CLASSES_MAP = {
//     success: 'pt-icon-success',
//     warning: 'pt-icon-warning',
//     error: 'pt-icon-error',
//     info: 'pt-icon-info',
// } as const;
const TYPE_CLASSES_MAP = {
    success: 'pt-icon-Success',
    warning: 'pt-icon-Remind',
    error: 'pt-icon-solid-close',
    info: 'pt-icon-info',
} as const;

interface Props {
    title?: string;
    description?: string;
    type: 'success' | 'info' | 'error' | 'warning';
    closable: boolean;
    closeText?: string;
    showIcon?: boolean;
    center: boolean;
    effect: 'light' | 'dark';
}
const props = withDefaults(defineProps<Props>(), {
    type: 'info',
    closable: true,
    center: false,
    effect: 'light',
});
const emit = defineEmits(['close']);
const slots = useSlots();

const visible = ref(true);

const typeClass = computed(() => `pt-alert--${props.type}`);
const iconClass = computed(() => TYPE_CLASSES_MAP[props.type]);
const isBigIcon = computed(() => (props.description || slots.default ? 'is-big' : ''));
const isBoldTitle = computed(() => (props.description || slots.default ? 'is-bold' : ''));

const close = (evt: Event) => {
    visible.value = false;
    emit('close', evt);
};
</script>

<style lang="scss" src="../../theme-chalk/src/alert.scss" />
